import * as types from '../constants/actionTypes';
import initialState from '../reducers/initialState';
import * as list from '../utils/list';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function approvedHourReducer(state = initialState.approvedHours, action) {
    let newState = state;

    switch (action.type) {
        case types.APPROVE_HOURS:
            if (action.status === 'success'){
                newState = approveHours(state, action.data.approvedHoursID, action.data.timesheetID);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.CM_LM_LOAD_APPROVED_HOURS_WEEK:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    cmlmApprovedHours: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.COUNT_UNAPPROVED_HOURS_WEEK:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    unapprovedHoursCount: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.CREATE_APPROVED_HOURS:
            if (action.status === 'success'){
                newState = createApprovedHours(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        case types.PMO_LOAD_APPROVABLE_HOURS:
            if (action.status === 'success'){
                newState = Object.assign({}, state, {
                    approvableHours: action.data,
                    loading: false
                });
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;

        /*case types.REJECT_APPROVED_HOURS:
            if (action.status === 'success'){
                newState = rejectApprovedHours(state, action.data);
            }
            if (action.status === 'failure'){
                newState = Object.assign({}, state, {
                    error: action.data,
                    loading: false
                });
            }
            return newState;*/

        case types.SET_LOADING_FLAG_FOR_APPROVED_HOUR_STATE:
            return Object.assign({}, state, {
                loading: true
            });

        default:
            return state;
    }
}

function approveHours (state, approvedHoursID, timesheetID) {
    let approvableHours = [...state.approvableHours];
    let approvedHours = [...state.approvedHours];

    let index = list.findIndexByID(approvedHours, approvedHoursID);
    approvedHours.push(approvedHours[index]);
    approvableHours = list.remove(approvableHours, index);

    let newState = Object.assign({}, state, {
        loading: false,
        approvableHours: approvableHours,
        approvedHours: approvedHours
    });
    return newState;
}

function createApprovedHours (state, approvedHours) {
    return Object.assign({}, state, {
        loading: false,
        approvedHours: [...state.approvedHours, approvedHours]
    });
}

function rejectApprovedHours (state, data) {
    let approvedHourList = state.approvedHours;

    let index = list.findIndexByID(approvedHourList, data.approvedHoursID);

    approvedHourList[index].rejectMessage = data.rejecter.givenName + " " + data.rejecter.surname + ": " + data.message;
    approvedHourList[index].timeApproved = 0;
    approvedHourList[index].timePrevRejected = approvedHourList[index].timeTotal;
    approvedHourList[index].overtimePrevRejected = approvedHourList[index].timeOvertime;
    approvedHourList[index].rejectedAt = data.rejectedAt;
    approvedHourList[index].approvable = false;

    let newState = Object.assign({}, state, {
        loading: false,
        approvedHours: approvedHourList
    });
    return newState;
}



/** WEBPACK FOOTER **
 ** ./src/app/reducers/approvedHourReducer.js
 **/